import { useContext, useEffect } from "react";
import Application from "../../components/application";
import Button from "@mui/material/Button";
import SchoolIcon from '@mui/icons-material/School';
import { useNavigate } from "react-router-dom";
import GridView from "../../components/views/gridView";
import {Tooltip} from "@mui/material";
import useColaboradoresState from "../../hooks/useColaboradoresState";
import TELAS from "../../constants/telas";
import TELA_ACOES from "../../constants/telaAcoes";
import { AuthContext } from "../../contexts/auth";
import permissaoTelas from "../../utils/permissaoTelas";

// permissão para telas
const PAGINA = {
    aplicacao: 'SisPalo - Colaborador',
    funcionalidade: 'Cursos',
    tela: TELAS.COLABORADORES,
    acoes: [TELA_ACOES.Consultar]
}


const Colaboradores = () => {

    const states = useColaboradoresState()
    const navigate = useNavigate()
    const {permissaoUsuario} = useContext(AuthContext); /* permissão para telas*/    

    /* permissão para telas*/
    useEffect(()=>{
        if (permissaoTelas(permissaoUsuario, TELA_ACOES.Consultar, PAGINA)){
            if (states.pesquisa.value === ''){
                states.submit.set()
            }
        }
        else {
            navigate('/gestor/dashboard')
        }

    }, [])


    useEffect(()=>{
        if (states.pesquisa.value === ''){
            states.submit.set()
        }

    }, [states.pesquisa.value])
    

    const columns = [
        {field:'company', headerName:'Coligada', width: 150},
        {field:'name', headerName:'Nome', flex: 1, width: 500},
        {field:'postcompany', headerName:'Nome Posto', flex: 1, width: 300},        
        {filed:'', headerName:'Ações', width:80, renderCell: (cellValues) =>{
            return (
                <>
                    <Tooltip title="Cursos Assistidos" placement="bottom" arrow>
                        <Button 
                            disabled={!permissaoTelas(permissaoUsuario, TELA_ACOES.Consultar, PAGINA)}
                            onClick={()=>navigate(`/gestor/colaboradores/${cellValues.row.user_id}`)} sx={{width:'55px', padding: 0,minWidth:0}}><SchoolIcon /></Button>
                    </Tooltip>
                </>
            )
        }}
    ]


    
    return (
   
        <Application>
            <>
                <GridView 
                    title='Colaboradores' 
                    states={states}
                    rows={states.colaboradores.value}
                    columns={columns}
                    urlVoltar={'/gestor/dashboard'}
                    onClickPesquisa={()=>{states.submit.set()}}
                    nomeItem='colaborador'
                />
            </>
        </Application>
   
    )
}

export default Colaboradores;